
import React from 'react';
import './AboutPage.css';

import AboutHero from '../../components/AboutPage/AboutHero/AboutHero';
import OurStorySection from '../../components/AboutPage/OurStorySection/OurStorySection';
import MvtSection from '../../components/AboutPage/MvtSection/MvtSection'; 

export default function AboutPage() {
  return (
    <div className="about-page-wrapper">
      <AboutHero />
      <OurStorySection />
      <MvtSection /> 
    </div>
  );
}